import { useTranslation } from 'react-i18next';
import type { ContentLang } from '../services/articleService';

// Idioma do conteúdo = idioma da interface (derivado do produto do usuário em App.tsx).
export function useContentLang(): ContentLang {
  const { i18n } = useTranslation();
  return i18n.language === 'es' ? 'es' : 'pt';
}
